import { css } from 'lit'

export default css`
    :host {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
    }

    .icon {
        width: 19px;
        height: 19px;
        background-color: var(--grey7);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
        flex-shrink: 0;
        font-size: 0.5rem;
    }

    .icon.small {
        width: 17px;
        height: 17px;
    }

    .icon.faded {
        background-color: var(--grey5);
    }

    .icon g {
        fill: var(--grey1);
    }

    .icon.faded g {
        fill: var(--lightGrey);
    }

    .name {
        font-size: 12px;
        font-weight: var(--font-weight-medium);
        flex-grow: 0;
    }

    .name.heavy {
        font-size: 12px;
        font-weight: var(--font-weight-bold);
    }
`
